import { render } from "./TeacherCardAchievements.vue?vue&type=template&id=4a3c298c&scoped=true"
import script from "./TeacherCardAchievements.vue?vue&type=script&lang=js"
export * from "./TeacherCardAchievements.vue?vue&type=script&lang=js"

import "./TeacherCardAchievements.vue?vue&type=style&index=0&id=4a3c298c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3c298c"]])

export default __exports__